/**
 * CTAs sociales de la homepage (X y Telegram).
 * Define en `.env`: `VITE_SOCIAL_X_URL` y `VITE_SOCIAL_TELEGRAM_URL` (perfil o canal público).
 */
export const SOCIAL_X_URL = import.meta.env.VITE_SOCIAL_X_URL?.trim() || 'https://x.com/DontPanicDEX'
export const SOCIAL_TELEGRAM_URL =
  import.meta.env.VITE_SOCIAL_TELEGRAM_URL?.trim() || 'https://t.me/DontPanicDEX'
